import React, { useState, useEffect } from 'react';
import GSTR3BDashboard from '../GSTR3BDashboard';
import GSTPortalLogin from '../../components/gst/GSTPortalLogin';
import GSTPortalDashboard from '../../components/gst/GSTPortalDashboard';
import { trackActivity } from '../../lib/activity';

/**
 * GSTR-3B Simulator with GST Portal Login Screen
 * Flow: Login -> GST Portal Dashboard -> GSTR-3B Dashboard
 * Company data is shared from GST Registration
 */

// Default company data
const DEFAULT_COMPANY = {
  legalName: 'Demo Company Private Limited',
  tradeName: 'Demo Company',
  gstin: '07AAACG1234A1ZM',
  state: 'Delhi',
  filingPreference: 'Monthly'
};

const Gstr3bSimulator = () => {
  const [step, setStep] = useState('login'); // login -> portal -> dashboard
  const [companyData, setCompanyData] = useState(DEFAULT_COMPANY);

  // Track simulator start (logged-in only, fire-and-forget)
  useEffect(() => {
    trackActivity({
      simulator_id: 'gstr3b',
      simulator_name: 'GSTR-3B Filing Simulator',
      action: 'started',
    });
  }, []);

  // Load company data from localStorage (from GST Registration)
  useEffect(() => {
    const savedData = localStorage.getItem('practiq_gst_company');
    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        setCompanyData({ ...DEFAULT_COMPANY, ...parsed });
      } catch (e) {
        console.error('Error loading company data:', e);
      }
    }
  }, []);

  const handleLogin = (credentials) => {
    console.log('GSTR-3B Login:', credentials);
    setStep('portal'); // Go to GST Portal Dashboard
  };

  const handleNavigateToDashboard = () => {
    setStep('dashboard'); // Go to GSTR-3B Dashboard
  };

  // Step 1: Login Screen
  if (step === 'login') {
    return <GSTPortalLogin onLogin={handleLogin} formType="GSTR-3B" />;
  }

  // Step 2: GST Portal Dashboard (like real GST portal after login)
  if (step === 'portal') {
    return (
      <GSTPortalDashboard 
        companyData={companyData} 
        onNavigate={handleNavigateToDashboard}
        formType="GSTR-3B"
      />
    );
  }

  // Step 3: Actual GSTR-3B Dashboard
  return <GSTR3BDashboard skipAuth={true} companyData={companyData} />;
};

export default Gstr3bSimulator;
